(function ($) {
  import(/* webpackChunkName: "iframe-resizer" */
  /* webpackPreload: true */
  /* webpackMode: 'lazy-once' */
  'iframe-resizer').then(function (foo) {
    window.DGS.OnLoad.getInstance().register(function () {
      try {
        $('iframe').iFrameResize();
      } catch (error) {
        // Fail silently!
      }
    });
    window.DGS.Event.getInstance().on('GDPR_IFRAME_ADDED', function () {
      $('iframe').iFrameResize();
    });
  }).catch(function (error) {
    console.log('An error occurred while loading the component for selector}');
    console.log(error);
  });
  if ($('.component iframe').length) {
    $('body').addClass('reset-overflow');
  }
})(jQuery);